import { z } from 'zod';
import { iconSchema } from './shared';

export const instrumentSchema = z.object({
  instrumentName: z.string(),
  icon: iconSchema,
  parentInstrument: z.object({ instrumentName: z.string() }).nullable().optional(),
});

export type InstrumentSchema = z.infer<typeof instrumentSchema>;

export const instrumentArraySchema = z.array(instrumentSchema);

export type InstrumentArraySchema = z.infer<typeof instrumentArraySchema>;

export const addedInstrument = z.object({
  name: z.string(),
  imageSrc: z.string(),
  skillLevel: z.string().optional(),
});

export type AddedInstrument = z.infer<typeof addedInstrument>;

export const addedInstruments = z.array(addedInstrument);

export type AddedInstruments = z.infer<typeof addedInstruments>;
